'use client';

import { faCircleCheck, faIcons, faPeopleLine, faPhotoFilm, faSchoolFlag } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";

type Props = {
  sectionName: string;
  optionsRef: any;
}

export default function SectionSelector(props: Props) {
  const { sectionName } = props;
  const [displaySection, setDisplaySection] = useState<number>(0);

  useEffect(() => {
    setDisplaySection(0);
  }, [sectionName]);

  const getSelectorStyling = (sectionName: string): {
    selectorColor: string;
    circleCut: string;
    circleCutPosition?: string;
  } => {
    switch (sectionName) {
      case 'acerca':
        return {
          selectorColor: 'bg-gradient-to-l from-[#589542] to-[#2E8034]',
          circleCut: '/images/circles/cutGreenCircle.png',
          circleCutPosition: 'right-0',
        }
      case 'eventos':
        return {
          selectorColor: 'bg-red',
          circleCut: '/images/circles/cutPinkCircle.png',
          circleCutPosition: 'left-0',
        }
      default:
       return {
          selectorColor: 'bg-gradient-to-l from-[#589542] to-[#2E8034]',
          circleCut: '/images/circles/cutGreenCircle.png',
        }
    }
  };

  const getAppointment = (sectionName: string): JSX.Element => {
    switch (sectionName) {
      case 'acerca':
        return <>
          <div className="flex items-center justify-center text-center mt-0 md:px-0 md:mt-4 xl:mt-0">
            <div className="border border-gray-200 rounded-bl-[100px] rounded-tr-[100px] py-8 px-16 xl:px-80 xl:py-10x">
              <p className="font-bold text-md mb-8 md:text-2xl md:mb-12">Vení a conocernos. ¡Agendá tu cita hoy!</p>
              <Link href='#' className="text-white font-bold text-sm rounded-full py-3 px-4 shadow-sm bg-gradient-to-r from-orange to-[#FBA919] hover:shadow-lg md:text-nowrap md:px-10">Agendar visita</Link>
            </div>
          </div>
        </>
      case 'eventos':
        return <></>
      default:
        return <></>
    }
  }

  const getSelectorBar = (sectionName: string): JSX.Element => {
    switch (sectionName) {
      case 'acerca':
        return <>
          <h2 className="font-bold text-white text-2xl py-8"> Aquí hacemos las cosas  <span className="inline-block relative after:absolute after:h-1 after:rounded-full after:block after:bg-yellow after:w-full after:-bottom-1 after:right-0">distinto</span> </h2>
          <div className="flex justify-between rounded-full bg-green-dark px-1 py-1.5 transition ease-in-out delay-115 md:flex-row md:px-1.5 md:py-1.5 md:rounded-full">
            <button onClick={() => setDisplaySection(0)} className={`flex items-center px-3 py-2 md:px-8 md:py-2 rounded-full text-xs md:text-sm ${displaySection !== 0 ? 'text-white' : 'font-bold text-orange bg-white'}`}>
              <FontAwesomeIcon icon={faPhotoFilm} className="hidden md:block mr-2" /><span>La metodología</span>
            </button>
            <button onClick={() => setDisplaySection(1)} className={`flex items-center px-3 py-2 md:px-8 md:py-2 rounded-full text-xs md:text-sm ${displaySection !== 1 ? 'text-white' : 'font-bold text-orange bg-white'}`}>
              <FontAwesomeIcon icon={faPeopleLine} className="hidden md:block mr-2" /><span>La calidad</span>
            </button>
            <button onClick={() => setDisplaySection(2)} className={`flex items-center px-3 py-2 md:px-8 md:py-2 rounded-full text-xs md:text-sm ${displaySection !== 2 ? 'text-white' : 'font-bold text-orange bg-white'}`}>
              <FontAwesomeIcon icon={faSchoolFlag} className="hidden md:block mr-2" /><span>La tecnología</span>
            </button>
            <button onClick={() => setDisplaySection(3)} className={`flex items-center px-3 py-2 md:px-8 md:py-2 rounded-full text-xs md:text-sm ${displaySection !== 3 ? 'text-white' : 'font-bold text-orange bg-white'}`}>
              <FontAwesomeIcon icon={faIcons} className="hidden md:block mr-2" /><span>La exposición</span>
            </button>
          </div>
        </>
      case 'eventos':
        return <>
          <h2 className="text-center font-bold text-2xl py-8 md:text-4xl">Te ayudamos con: </h2>
          <div className="flex justify-between rounded-full bg-[#AD222A59]/35 px-1 py-1.5 transition ease-in-out delay-115 md:flex-row md:px-1.5 md:py-1.5 md:rounded-full">
            <button onClick={() => setDisplaySection(0)} className={`flex items-center px-3 py-0.5 rounded-full text-xs md:px-8 md:py-2 md:text-sm ${displaySection !== 0 ? 'text-white' : 'font-bold text-red bg-white'}`}>
              <FontAwesomeIcon icon={faPeopleLine} className="hidden md:block mr-2" /><span>Experiencias</span>
            </button>
            <button onClick={() => setDisplaySection(1)} className={`flex items-center px-3 py-2 rounded-full text-xs md:px-8 md:py-2 md:text-sm ${displaySection !== 1 ? 'text-white' : 'font-bold text-red bg-white'}`}>
              <FontAwesomeIcon icon={faSchoolFlag} className="hidden md:block mr-2" /><span>Eventos y reuniones</span>
            </button>
            <button onClick={() => setDisplaySection(2)} className={`flex items-center px-3 py-2 rounded-full text-xs md:px-8 md:py-2 md:text-sm ${displaySection !== 2 ? 'text-white' : 'font-bold text-red bg-white'}`}>
              <FontAwesomeIcon icon={faIcons} className="hidden md:block mr-2" /><span>Creación de contenido</span>
            </button>
            <button onClick={() => setDisplaySection(3)} className={`flex items-center px-3 py-2 rounded-full text-xs md:px-8 md:py-2 md:text-sm ${displaySection !== 3 ? 'text-white' : 'font-bold text-red bg-white'}`}>
              <FontAwesomeIcon icon={faPhotoFilm} className="hidden md:block mr-2" /><span>Producción audiovisual</span>
            </button>
          </div>
        </>
      default:
        return <></>;
    }
  };

  const getSectionContent = (sectionName: string, displaySection: number): JSX.Element => {
    if (sectionName === 'acerca') {
      switch (displaySection) {
        case 0:
          return (
            <div className="relative mx-4 py-16 md:py-16">
              <h1 className="text-[#A2B645] font-bold text-md">La metodología</h1>
              <p className="font-bold text-white text-4xl">Una enseñanza <span className="font-thin">basada en la práctica</span></p>
              <div className="flex md:flex-col xl:flex-row">
                <Image src="/images/acerca/calidad.jpg" width={600} height={384} className="hidden md:block rounded-3xl mt-8" alt="Chefs" />
                <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-8 md:-left-10 md:top-24">
                  <Image src="/images/lines/halfCirclesYellowDarkGreen.png" width={400} height={208} className="hidden md:block absolute top-32 -left-[22px] z-10" alt="Decoration" unoptimized/>
                  <p className="font-light text-md md:text-lg md:mx-8">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <div className="flex flex-col items-center font-bold text-sm mt-8 gap-4 md:text-lg md:items-start md:mx-8">
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Diseño de experiencias para cliente final o intermediarios</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Campañas en Redes Sociales</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Creación de recetas y usos de materias primas</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Focus groups y pruebas de productos</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-center font-bold mt-24 py-4 md:text-left md:mt-32">Ponemos a disposición:</p>
              <div className="flex flex-col gap-8 items-center text-sm px-8 md:flex-row md:text-md md:items-start md:px-0">
                <div>
                  <div className="flex items-center mb-4">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Chefs entrenados para aparecer en cámara y crear contenidos</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Red en la industria de A y B: Sommeliers, Distribuidores, Chefs, Asociaciones</p>
                  </div>
                </div>
                <div>
                  <div className="flex items-center mb-8">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Especialistas en comunicación gastronómica</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Diseño gráfico, Fotografía y Diseño web</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                  <p>Red de micro influencers gastronómicos</p>
                </div>
              </div>
            </div>
          );
        case 1:
          return (
            <div className="relative z-20 mx-4 py-16 md:py-16">
              <h1 className="text-[#A2B645] font-bold text-md">La calidad</h1>
              <p className="font-bold text-white text-4xl">Una enseñanza <span className="font-thin">basada en la práctica</span></p>
              <div className="flex md:flex-col xl:flex-row">
                <Image src="/images/acerca/metodologia.jpg" width={600} height={384} className="hidden md:block rounded-3xl mt-8" alt="Chefs" />
                <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-8 md:-left-10 md:top-24">
                  <Image src="/images/lines/halfCirclesYellowDarkGreen.png" width={400} height={208} className="hidden md:block absolute top-32 -left-[22px] z-10" alt="Decoration" unoptimized/>
                  <p className="font-light text-md md:text-lg md:mx-8">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <div className="flex flex-col items-center font-bold text-sm mt-8 gap-4 md:text-lg md:items-start md:mx-8">
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Diseño de experiencias para cliente final o intermediarios</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Campañas en Redes Sociales</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Creación de recetas y usos de materias primas</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Focus groups y pruebas de productos</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-center font-bold mt-8 py-4 md:text-left md:mt-32">Ponemos a disposición:</p>
              <div className="flex flex-col gap-8 items-center text-sm px-8 md:flex-row md:text-md md:items-start md:px-0">
                <div>
                  <div className="flex items-center mb-4">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Chefs entrenados para aparecer en cámara y crear contenidos</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Red en la industria de A y B: Sommeliers, Distribuidores, Chefs, Asociaciones</p>
                  </div>
                </div>
                <div>
                  <div className="flex items-center mb-8">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Especialistas en comunicación gastronómica</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Diseño gráfico, Fotografía y Diseño web</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                  <p>Red de micro influencers gastronómicos</p>
                </div>
              </div>
            </div>
          );
        case 2:
          return (
            <div className="relative z-20 mx-4 py-16 md:py-16">
              <h1 className="text-[#A2B645] font-bold text-md">La tecnología</h1>
              <p className="font-bold text-white text-4xl">Una enseñanza <span className="font-thin">basada en la práctica</span></p>
              <div className="flex md:flex-col xl:flex-row">
                <Image src="/images/acerca/tecnologia.jpg" width={600} height={384} className="hidden md:block rounded-3xl mt-8" alt="Chefs" />
                <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-8 md:-left-10 md:top-24">
                  <Image src="/images/lines/halfCirclesYellowDarkGreen.png" width={400} height={208} className="hidden md:block absolute top-32 -left-[22px] z-10" alt="Decoration" unoptimized/>
                  <p className="font-light text-md md:text-lg md:mx-8">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <div className="flex flex-col items-center font-bold text-sm mt-8 gap-4 md:text-lg md:items-start md:mx-8">
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Diseño de experiencias para cliente final o intermediarios</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Campañas en Redes Sociales</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Creación de recetas y usos de materias primas</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Focus groups y pruebas de productos</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-center font-bold mt-8 py-4 md:text-left md:mt-32">Ponemos a disposición:</p>
              <div className="flex flex-col gap-8 items-center text-sm px-8 md:flex-row md:text-md md:items-start md:px-0">
                <div>
                  <div className="flex items-center mb-4">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Chefs entrenados para aparecer en cámara y crear contenidos</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Red en la industria de A y B: Sommeliers, Distribuidores, Chefs, Asociaciones</p>
                  </div>
                </div>
                <div>
                  <div className="flex items-center mb-8">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Especialistas en comunicación gastronómica</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Diseño gráfico, Fotografía y Diseño web</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                  <p>Red de micro influencers gastronómicos</p>
                </div>
              </div>
            </div>
          );
        case 3:
          return (
            <div className="relative z-20 mx-4 py-16 md:py-16">
              <h1 className="text-[#A2B645] font-bold text-md">La exposición</h1>
              <p className="font-bold text-white text-4xl">Una enseñanza <span className="font-thin">basada en la práctica</span></p>
              <div className="flex md:flex-col xl:flex-row">
                <Image src="/images/acerca/exposicion.jpg" width={600} height={384} className="hidden md:block rounded-3xl mt-8" alt="Chefs" />
                <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-8 md:-left-10 md:top-24">
                  <Image src="/images/lines/halfCirclesYellowDarkGreen.png" width={400} height={208} className="hidden md:block absolute top-32 -left-[22px] z-10" alt="Decoration" unoptimized/>
                  <p className="font-light text-md md:text-lg md:mx-8">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <div className="flex flex-col items-center font-bold text-sm mt-8 gap-4 md:text-lg md:items-start md:mx-8">
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Diseño de experiencias para cliente final o intermediarios</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Campañas en Redes Sociales</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Creación de recetas y usos de materias primas</p>
                    </div>
                    <div className="flex items-center mb-2">
                      <FontAwesomeIcon icon={faCircleCheck} className="text-yellow mr-4"/>
                      <p>Focus groups y pruebas de productos</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-center font-bold mt-8 py-4 md:text-left md:mt-32">Ponemos a disposición:</p>
              <div className="flex flex-col gap-8 items-center text-sm px-8 md:flex-row md:text-md md:items-start md:px-0">
                <div>
                  <div className="flex items-center mb-4">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Chefs entrenados para aparecer en cámara y crear contenidos</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p className="max-w-xs">Red en la industria de A y B: Sommeliers, Distribuidores, Chefs, Asociaciones</p>
                  </div>
                </div>
                <div>
                  <div className="flex items-center mb-8">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Especialistas en comunicación gastronómica</p>
                  </div>
                  <div className="flex items-center">
                    <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Diseño gráfico, Fotografía y Diseño web</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="bg-green-light rounded-full h-1.5 w-1.5 mr-4"/>
                  <p>Red de micro influencers gastronómicos</p>
                </div>
              </div>
            </div>
          );
        default:
          return <></>;
      }
    } else if (sectionName === 'eventos') {
        switch (displaySection) {
          case 0:
            return (
              <div className="relative mx-4 pt-16 md:py-16">
                <h1 className="text-[#FBD4C1] font-bold text-md">Experiencias</h1>
                <p className="font-bold text-white text-4xl">Experiencias únicas <span className="font-thin">con un gran impacto</span></p>
                <div className="flex md:flex-col xl:flex-row">
                  <Image src="/images/events-experiences/experiencias.png" width={600} height={384} className="hidden md:block rounded-lg mt-8" alt="Experiencias" />
                  <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-0 md:-left-10 md:top-24 md:py-8">
                    <Image src="/images/lines/halfCirclesRedPink.png" width={46} height={208} className="hidden md:block absolute top-24 -left-[23px] z-10" alt="Decoration" unoptimized/>
                    <div className="flex flex-col items-center font-bold text-sm mt-4 gap-4 md:text-lg md:items-start md:mx-8">
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Entrenamientos a fuerza de ventas</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Presentación a canal de distribución</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Laboratorio desarrollo e investigación</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Team buildings</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Focus Groups</p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-center font-bold mt-[257px] py-4 md:text-left md:mt-32">Ponemos a disposición:</p>
                <div className="flex flex-col gap-8 items-center text-center text-sm px-8 md:flex-row md:items-start md:text-left md:px-0">
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Chefs asesores en diferentes especialidades</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Asistentes de cocina con experiencia</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Equipo profesional</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Ingredientes</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Diseño de la Experiencia</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Equipo audiovisual Red internet</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Salones amplios para servicio</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Personal de Servicio</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mb-4 md:justify-start">
                    <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Parqueo y seguridad</p>
                  </div>
                </div>

              </div>
            );
          case 1:
            return (
              <div className="relative mx-4 pt-16 md:py-16">
                <h1 className="text-[#FBD4C1] font-bold text-md">Eventos y reuniones</h1>
                <p className="font-bold text-white text-4xl">Una enseñanza <span className="font-thin">basada en la práctica</span></p>
                <div className="flex md:flex-col xl:flex-row">
                  <Image src="/images/events-experiences/eventos.png" width={600} height={384} className="hidden md:block rounded-lg mt-8" alt="Eventos y reuniones" />
                  <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-8 md:-left-10 md:top-24">
                    <Image src="/images/lines/halfCirclesRedPink.png" width={46} height={208} className="hidden md:block absolute top-24 -left-[23px] z-10" alt="Decoration" unoptimized/>
                    <div className="flex flex-col items-center font-bold text-sm mt-4 gap-4 md:text-lg md:items-start md:mx-8">
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Lanzamiento de producto</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Presentación a canal de distribución</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Demostraciones</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Focus Groups</p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-center font-bold mt-[235px] py-4 md:text-left mt:mt-8 xl:mt-32">Ponemos a disposición:</p>
                <div className="flex flex-col gap-8 items-center text-center text-sm px-8 md:flex-row md:items-start md:text-left md:px-0">
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Salones amplios para servicio</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Personal de Servicio</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Parqueo y seguridad</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Personal técnico</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Servicio de alimentos</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Equipo audiovisual Red internet</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center md:justify-start">
                    <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Red internet exclusiva</p>
                  </div>
                </div>

              </div>
            );
          case 2:
            return (
              <div className="relative z-20 mx-4 pt-16 md:py-16">
                <h1 className="text-[#FBD4C1] font-bold text-md">Creación de contenidos</h1>
                <p className="font-bold text-white text-4xl">Contenido de calidad<span className="font-thin"> que engancha audiencias</span></p>
                <div className="flex md:flex-col xl:flex-row">
                  <Image src="/images/events-experiences/contenido.png" width={600} height={384} className="hidden md:block rounded-lg mt-8" alt="Creación de contenido" />
                  <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-8 md:-left-10 md:top-24">
                    <Image src="/images/lines/halfCirclesRedPink.png" width={46} height={208} className="hidden md:block absolute top-24 -left-[23px] z-10" alt="Decoration" unoptimized/>
                    <div className="flex flex-col items-center font-bold text-sm mt-4 gap-4 md:text-lg md:items-start md:mx-8">
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Diseño de experiencias para cliente final o intermediarios</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Campañas en Redes Sociales</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Creación de recetas y usos de materias primas</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Focus groups y pruebas de productos</p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-center font-bold mt-[160px] py-4 md:text-left md:mt-32">Ponemos a disposición:</p>
                <div className="flex flex-col gap-8 items-center text-center text-sm px-8 md:flex-row md:items-start md:text-left md:px-0">
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Chefs entrenados para aparecer en cámara y crear contenidos</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Red en la industria de A y B: Sommeliers, Distribuidores, Chefs, Asociaciones</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-8 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Especialistas en comunicación gastronómica</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Diseño gráfico, Fotografía y Diseño web</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center md:justify-start">
                    <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Red de micro influencers gastronómicos</p>
                  </div>
                </div>
              </div>
            );
          case 3:
            return (
              <div className="relative z-50 mx-4 pt-16 md:py-16">
                <h1 className="text-[#FBD4C1] font-bold text-md">Producción audiovisual</h1>
                <p className="font-bold text-white text-4xl">Material original <span className="font-thin">con verdaderos expertos en cocina</span></p>
                <div className="flex md:flex-col xl:flex-row">
                  <Image src="/images/events-experiences/produccion.png" width={600} height={384} className="hidden md:block rounded-lg mt-8" alt="Producción audiovisual" />
                  <div className="relative -left-0 top-8 bg-white rounded-3xl w-[600px] px-8 py-8 md:-left-10 md:top-24">
                    <Image src="/images/lines/halfCirclesRedPink.png" width={46} height={208} className="hidden md:block absolute top-24 -left-[23px] z-10" alt="Decoration" unoptimized/>
                    <div className="flex flex-col items-center font-bold text-sm mt-4 gap-4 md:text-lg md:items-start md:mx-8">
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Reels</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Videos para redes sociales</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Stream</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>FB Live, Zoom, Google Meet, Teams</p>
                      </div>
                      <div className="flex items-center mb-2">
                        <FontAwesomeIcon icon={faCircleCheck} className="text-red mr-4"/>
                        <p>Demostraciones virtuales</p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-center font-bold mt-[195px] py-4 md:text-left md:mt-32">Ponemos a disposición:</p>
                <div className="flex flex-col gap-8 items-center text-center text-sm px-8 md:flex-row md:items-start md:text-left md:px-0">
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Personal técnico</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p className="max-w-xs">Iluminación</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Cámaras profesionales</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Audio</p>
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-center mb-4 md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Diseño de guión</p>
                    </div>
                    <div className="flex items-center justify-center md:justify-start">
                      <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                      <p>Equipo y menaje</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center md:justify-start">
                    <span className="bg-red rounded-full h-1.5 w-1.5 mr-4"/>
                    <p>Set de cocina con todos los equipos</p>
                  </div>
                </div>

              </div>
            );
          default:
            return <></>;
        } 
    } else {
      return <></>;
    }
  };

  if (!sectionName) {
    return null;
  }

  const styling = getSelectorStyling(sectionName);
  
  return (
    <section ref={props.optionsRef} className={`${styling.selectorColor} relative rounded-lg rounded-br-[100px] max-h-[800px] my-16 md:my-16`}>
      {styling?.circleCut && (
        <Image src={styling.circleCut} width={500} height={500} className={`${styling.circleCutPosition || ''} absolute top-0 z-0`} alt="Decoration" sizes="(max-width: 768px) 300px, 500px" quality={75}/>
      )}
      <div className="relative mx-auto py-0 md:px-8 md:py-8 bigscreen-responsive md:mb-32">
        <div className="flex flex-col items-center justify-center">
          { getSelectorBar(sectionName) }
        </div>
        {displaySection === 0 &&
          <div>
            { getSectionContent(sectionName, displaySection) }
            { getAppointment(sectionName) }
          </div>
        }
        {displaySection === 1 &&
          <div>
            { getSectionContent(sectionName, displaySection) }
            { getAppointment(sectionName) }
          </div>
        }
        {displaySection === 2 &&
          <div>
            { getSectionContent(sectionName, displaySection) }
            { getAppointment(sectionName) }
          </div>
        }
        {displaySection === 3 &&
          <div>
            { getSectionContent(sectionName, displaySection) }
            { getAppointment(sectionName) }
          </div>
        }
      </div>
    </section>
  );
}